var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPersonLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 11.66C14.5301 11.66 16.5807 9.60946 16.5807 7.08C16.5807 4.55054 14.5301 2.5 12.0007 2.5C9.47119 2.5 7.42065 4.55054 7.42065 7.08C7.42065 9.60946 9.47119 11.66 12.0007 11.66Z",
    fill: "#FFC82A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3219 21.4999C15.0294 21.4999 8.9731 21.4999 5.6806 21.4999C4.36185 21.4999 3.38935 20.2424 3.7506 18.9749C4.79685 15.3074 8.09435 12.8486 12.0006 12.8486C15.9069 12.8486 19.2044 15.3074 20.2506 18.9749C20.6119 20.2424 19.6394 21.4999 18.3206 21.4999H18.3219Z",
    fill: "#FFC82A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2066 15.2651C12.5216 15.2651 12.1741 15.6689 12.0516 15.8514C12.0266 15.8876 11.9741 15.8876 11.9491 15.8514C11.8279 15.6701 11.4804 15.2651 10.7941 15.2651C9.8566 15.2651 9.4541 16.1814 9.4541 16.7439C9.4541 17.6689 10.0379 18.1926 10.7941 18.8939L11.6791 19.6339C11.8654 19.7889 12.1354 19.7889 12.3204 19.6339L13.2054 18.8939C13.9616 18.1926 14.5454 17.6689 14.5454 16.7439C14.5454 16.1814 14.1429 15.2651 13.2054 15.2651H13.2066Z",
    fill: "#F0464F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonLove);
export default __webpack_public_path__ + "static/media/icon_person_love.6c829e63.svg";
export { ForwardRef as ReactComponent };